import { Box, Flex, SimpleGrid } from '@chakra-ui/react';
import Card from 'components/card/Card';

const Bone = ({ w = '100%', h = '14px', r = '10px', mt }) => (
  <Box className="nr-shimmer" w={w} h={h} borderRadius={r} mt={mt} />
);

export const TableShimmer = ({ rows = 8, columns = 5 }) => (
  <Card className="nr-page-card" flexDirection="column" w="100%" px="0px" overflow="hidden">
    <Flex px="24px" py="20px" justify="space-between" align="center" gap="16px">
      <Bone w="180px" h="22px" />
      <Flex gap="12px" flex="1" justify="flex-end">
        <Bone w={{ base: '100%', md: '260px' }} h="42px" r="21px" />
        <Bone w="120px" h="42px" r="21px" />
      </Flex>
    </Flex>
    <Box px="24px" pb="8px">
      <Flex gap="16px" mb="16px">
        {Array.from({ length: columns }).map((_, index) => (
          <Bone key={`head-${index}`} w={`${Math.max(10, 90 / columns)}%`} h="12px" />
        ))}
      </Flex>
      {Array.from({ length: rows }).map((_, row) => (
        <Flex key={`row-${row}`} gap="16px" align="center" py="14px" borderTop="1px solid rgba(17,24,18,0.06)">
          {Array.from({ length: columns }).map((__, col) => (
            <Bone
              key={`cell-${row}-${col}`}
              w={`${Math.max(10, 90 / columns)}%`}
              h={col === 0 ? '36px' : '14px'}
              r={col === 0 ? '10px' : '8px'}
            />
          ))}
        </Flex>
      ))}
    </Box>
  </Card>
);

export const FormShimmer = ({ fields = 6 }) => (
  <Card className="nr-page-card" w="100%" p={{ base: '20px', md: '28px' }}>
    <Bone w="220px" h="24px" />
    <Bone w="320px" h="14px" mt="10px" />
    <SimpleGrid columns={{ base: 1, md: 2 }} gap="18px" mt="28px">
      {Array.from({ length: fields }).map((_, index) => (
        <Box key={index}>
          <Bone w="90px" h="12px" />
          <Bone w="100%" h="46px" r="14px" mt="10px" />
        </Box>
      ))}
    </SimpleGrid>
    <Bone w="100%" h="120px" r="16px" mt="18px" />
    <Flex justify="flex-end" mt="24px" gap="12px">
      <Bone w="110px" h="42px" r="21px" />
      <Bone w="140px" h="42px" r="21px" />
    </Flex>
  </Card>
);

export const StatsShimmer = ({ cards = 8 }) => (
  <Box>
    <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} gap="20px" mb="30px">
      {Array.from({ length: cards }).map((_, index) => (
        <Card key={index} py="18px" px="18px">
          <Flex align="center" gap="16px">
            <Bone w="56px" h="56px" r="50%" />
            <Box flex="1">
              <Bone w="70%" h="12px" />
              <Bone w="40%" h="22px" mt="10px" />
            </Box>
          </Flex>
        </Card>
      ))}
    </SimpleGrid>
    <TableShimmer rows={6} columns={4} />
  </Box>
);

export const PageShimmer = ({ variant = 'table', ...props }) => {
  if (variant === 'form') return <FormShimmer {...props} />;
  if (variant === 'stats') return <StatsShimmer {...props} />;
  return <TableShimmer {...props} />;
};

export default PageShimmer;
